<template>
  <div class="content">
    <div class="body">
      <div>
        <div class="table-wrap">
          <el-table
            v-loading="loading"
            :data="list"
            border
            style="width: 100%">
            <el-table-column
              prop="账龄类型"
              label="账龄类型"
              align="center">
            </el-table-column>
            <el-table-column
              label="当前欠费" align="center">
              <el-table-column
                prop="计划户数"
                label="户数"
                align="center">
              </el-table-column>
              <el-table-column
                prop="计划资金"
                label="金额"
                align="center">
              </el-table-column>
            </el-table-column>

            <el-table-column
              label="已回款" align="center">
              <el-table-column
                prop="完成户数"
                label="户数"
                align="center">
              </el-table-column>
              <el-table-column
                prop="完成资金"
                label="金额"
                align="center">
              </el-table-column>
            </el-table-column>

            <el-table-column
              label="完成率" align="center">
              <el-table-column
                prop="完成户数率"
                label="户数"
                align="center">
              </el-table-column>
              <el-table-column
                prop="完成资金率"
                label="金额"
                align="center">
              </el-table-column>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {CommonHelp} from "../../common/CommonHelp";
import ButlerHttp from "../../common/ButlerHttp";

export default {
  name: "AgingType",
  inject:['where','reginWhere'],
  props:{
    types:{
      type:String,
      default(){
        return ""
      }
    }
  },
  data(){
    return{
      where2:{
        type:0,
      },
      loading:false,
      list:[],
      house_bill_order:[],
    }
  },
  mounted() {
    const that=this;
    that.getData();
  },
  watch:{
    "reginWhere.type_id":function (n,o) {
      this.getData()
    },
    "reginWhere.project_region":function (n,o) {
      this.getData()
    },
    "reginWhere.project_name":function (n,o) {
      this.getData()
    },
    "reginWhere.area_id":function (n,o) {
      this.getData()
    },
    "where2.type":function (n,o) {
      this.getData()
    },
  },
  methods:{
    getList(){
      const that = this;
      that.loading = true;

      let where = {
        ...that.where2,
        project_ids:that.reginWhere.project_ids,
        project_id:that.reginWhere.project_name,
        area_id:that.reginWhere.area_id,
        types:that.types,
      }

      ButlerHttp.post("LegalStatistics/getAgingType", {
        ...where
      }, res => {
        if (res.code) {
          that.list = res.data;
        }
        that.loading = false;
      });
    },
    getData(){
      const that=this;
      CommonHelp.debounce(()=>{
        that.getList()
      },500,that)
    }
  }
}

</script>

<style lang="scss" scoped>
@import "../../common";
.content{
  min-height: calc(100vh - 350px);

  .header-tip{
    margin: 5px 0;
    padding: 5px 10px;
    background-color: #f56c6c;
    color: #FFFFFF;
    border-radius: 4px;
    display: inline-block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/common/AgingType.vue